import axios from 'axios'

const microsoftSsoRequestConfig = {
  preserveSessionOnForbidden: true,
}

export interface MicrosoftSsoConfig {
  id: number
  microsoft_sso_enabled: boolean
  microsoft_sso_connected: boolean
  microsoft_tenant_id: string | null
  domains: string[]
}
export const getMicrosoftSso = async (companyId: number): Promise<MicrosoftSsoConfig> => (await axios.get(`/company/${companyId}/microsoft-sso`, microsoftSsoRequestConfig)).data.data
export const saveMicrosoftSso = async (companyId: number, tenantId: string, domains: string[], enabled: boolean): Promise<MicrosoftSsoConfig> => {
  const response = await axios.put(`/company/${companyId}/microsoft-sso`, { tenant_id: tenantId, domains, enabled }, microsoftSsoRequestConfig)
  return response.data.data
}
export const disconnectMicrosoftSso = async (companyId: number): Promise<MicrosoftSsoConfig> => (await axios.delete(`/company/${companyId}/microsoft-sso`, microsoftSsoRequestConfig)).data.data
export const startMicrosoftSso = async (companyId: number): Promise<string> => (await axios.get(`/company/${companyId}/microsoft-sso/start`, microsoftSsoRequestConfig)).data.authorization_url
